import script from "./OtpVerification.vue?vue&type=script&setup=true&lang=js"
export * from "./OtpVerification.vue?vue&type=script&setup=true&lang=js"

import "./OtpVerification.vue?vue&type=style&index=0&id=04987491&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04987491"]])

export default __exports__